import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider, useAuth } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import ServiziPage from './pages/ServiziPage';
import ShopPage from './pages/ShopPage';
import GiardinoPage from './pages/GiardinoPage';
import GiardinoDetailPage from './pages/GiardinoDetailPage';
import CommunityPage from './pages/CommunityPage';
import ChiSiamoPage from './pages/ChiSiamoPage';
import ContattiPage from './pages/ContattiPage';
import AuthPage from './pages/AuthPage';
import ClientDashboardPage from './pages/ClientDashboardPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import CookiePolicyPage from './pages/CookiePolicyPage';
import TerminiServizioPage from './pages/TerminiServizioPage';
import CookieBanner from './components/CookieBanner';
import WhatsAppButton from './components/WhatsAppButton';
import ScrollToTopButton from './components/ScrollToTopButton';
import './App.css';
import './i18n';

// Protected route: requires login
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[var(--color-cream)]">
        <div className="spinner" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

// Admin route: requires admin role
const AdminRoute = ({ children }) => {
  const { user, loading, isAdmin } = useAuth();
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[var(--color-cream)]">
        <div className="spinner" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (!isAdmin) return <Navigate to="/area-clienti" replace />;
  return children;
};

function AppRoutes() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/servizi" element={<ServiziPage />} />
        <Route path="/shop" element={<ShopPage />} />
        <Route path="/giardino-delle-stelle" element={<GiardinoPage />} />
        <Route path="/giardino-delle-stelle/:id" element={<GiardinoDetailPage />} />
        <Route path="/community" element={<CommunityPage />} />
        <Route path="/chi-siamo" element={<ChiSiamoPage />} />
        <Route path="/contatti" element={<ContattiPage />} />
        <Route path="/login" element={<AuthPage mode="login" />} />
        <Route path="/registrati" element={<AuthPage mode="register" />} />
        <Route
          path="/area-clienti"
          element={
            <ProtectedRoute>
              <ClientDashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <AdminRoute>
              <AdminDashboardPage />
            </AdminRoute>
          }
        />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/cookie-policy" element={<CookiePolicyPage />} />
        <Route path="/termini-servizio" element={<TerminiServizioPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <AppRoutes />
            <CookieBanner />
            <WhatsAppButton />
            <ScrollToTopButton />
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
